import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import "./FreeLegalAdviceCSS.css";
import AskfreeQuestionForm from "./AskfreeQuestionForm";
import FAQsBox from "./FAQsBox";
import LegalBradcrumeSection from "./LegalBradcrumeSection";
import Checkbox from "@mui/material/Checkbox";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AllServicesCategory } from "../FetchAPI";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import { useAuth } from "../../Store/AuthContext";

export default function AskfreeQuestion() {
  const { RendomTokenfetch } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [AllserviceCat] = AllServicesCategory(RendomTokenfetch);

  const [selectedCategory, setSelectedCategory] = useState("1"); // Store selected category ID

  // console.log(selectedCategory);

  useEffect(() => {
    if (localStorage.getItem("userid") === null) {
      NotifyMessageNoReload(
        "Please login After Add Your Question.",
        "danger",
        true
      );
      navigate("/login", { state: { from: location.pathname } });
    }
  }, [navigate, location]);

  // Handle checkbox selection (only one can be selected)
  const handleCheckboxChange = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  return (
    <>
      <LegalBradcrumeSection
        Pagename={" Ask A Free Question Online"}
        page1={[{ name: "ask-a-free-question" }]}
      />

      <section
        className={`legal_section section_padding_top section_padding_bottom `}
        style={{ background: " #f5f7fc82" }}
      >
        <div className="auto-container">
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12">
              <p>Please Select A Category</p>
              <div className="servicecatbigbox">
                {AllserviceCat.map((catvalu, index) => (
                  <div
                    className="servicecatbox"
                    key={index}
                    onClick={() => handleCheckboxChange(catvalu.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="catboxhead">
                      <h4>{catvalu.category}</h4>
                      <Checkbox
                        checked={selectedCategory === catvalu.id}
                        onChange={() => handleCheckboxChange(catvalu.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">Ask a Free Question Online</h4>
                <p className="formdescPera">
                  Stuck with a issue? Submit your query below to get FREE
                  answers by email within a few hours. Expert advice from top
                  rated Expert in your city enables you to take better decisions
                  about your legal situation.
                </p>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    {selectedCategory && (
                      <AskfreeQuestionForm
                        RendomTokenfetch={RendomTokenfetch}
                        categoryId={selectedCategory}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">
                  <img
                    src="../images/Icons-16.svg"
                    className="headingsiteimg"
                    alt="no"
                  />
                  What are others saying?
                </h4>
                <p className="formdescPera">
                  “I got clear answers to my problem from top Expert within a
                  few minutes of posting a question at LawRato. It works like
                  magic"
                </p>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <h6>- Anuradha S</h6>
                  </div>
                </div>
              </div>

              <div className="formdesedataBOX">
                <h4 className="formdescheading">
                  <img
                    src="../images/Icons-18.svg"
                    className="headingsiteimg"
                    alt="no"
                  />
                  Talk to a top rated Expert
                </h4>
                <p className="formdescPera">
                  Contact a top rated Expert in your city to get detailed
                  opinion on your problem.
                </p>

                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <Link to="/free-advice" className="sencondBTNhover mb-3">
                      Talk to a Expert
                    </Link>
                  </div>
                </div>
              </div>

              <div className="formdesedataBOX">
                <h4 className="formdescheading">Latest Expert Answers</h4>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <ul className="formdataUL p-0 m-0">
                      <li className="formdataLI">
                        <Link className="formDatalink">
                          <i
                            className="fa fa-hand-o-right servileaglicon"
                            aria-hidden="true"
                          ></i>
                          Lended money to a friend in Pune
                        </Link>
                      </li>
                      <li className="formdataLI">
                        <Link className="formDatalink">
                          <i
                            className="fa fa-hand-o-right"
                            aria-hidden="true"
                          ></i>
                          Employee Dues - Execution UAE judgment in an Indian
                          court
                        </Link>
                      </li>
                      <li className="formdataLI">
                        <Link className="formDatalink">
                          <i
                            className="fa fa-hand-o-right"
                            aria-hidden="true"
                          ></i>
                          sir my son in law bitting my daughter
                        </Link>
                      </li>
                      <li className="formdataLI">
                        <Link className="formDatalink">
                          <i
                            className="fa fa-hand-o-right"
                            aria-hidden="true"
                          ></i>
                          How much maintenance n alimony n also how many yrs o
                          one time settleme
                        </Link>
                      </li>
                    </ul>
                    <Link to="/free-advice" className="sencondBTNhover mb-3">
                      Search All Answers
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row wow fadeInUp">
            <div className="col-lg-12 col-md-12">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">Frequently Asked Questions</h4>
                <div className="formdesctitlebox pb-4">
                  <div className="formDatarow">
                    <FAQsBox />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
